<template>
  <div>
    <zv-searchbar
      ref="outSearch"
      v-if="table.searchData &amp;&amp; table.searchData.length"
      :origin-query="table.query"
      :search-data="table.searchData"
      @on-search-change="search(table)"
      ><template slot="queryAfter"
        ><el-button
          type="primary"
          v-if="table.customSearchData &amp;&amp; table.customSearchData.length"
          @click="showCustomSearchDialog = true"
          style="float:left;"
          >自定义搜索</el-button
        ><slot name="customSearchAfter"></slot
      ></template>
      <span slot="customHeader">
        <slot name="ctrl-button-after"></slot> 
      </span>
      <span slot="after"><slot name="ctrl-button"></slot></span>
    </zv-searchbar>
    <el-table
      ref="searchTable"
      style="width: 100%;"
      :class="table.autoHeight ? 'style-auto-height' : ''"
      :height="tableHeight"
      tooltip-effect="dark"
      :data="table.data"
      @sort-change="sortChange"
      :row-key="table.treeProps ? table.treeProps['id'] : ''"
      :default-expand-all="table.defaultExpandAll"
      :tree-props="table.treeProps"
      v-loading="table.loading"
      element-loading-text="数据加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255,255,255,.4)"
      element-loading-custom-class="el-loading-mask-table"
      @select="handleSelect"
      @selection-change="handleSelectionChange"
      @select-all="handleSelectAll"
    >
      <el-table-column
        type="selection"
        width="50"
        v-if="table.columns.some(t =&gt; t.type === 'selection')"
      ></el-table-column>
      <el-table-column
        v-if="!table.hideOrder"
        min-width="50"
        label="ID"
        fixed="left"
        ><template slot-scope="scope"
          ><div v-if="scope.row.id">{{ scope.row.id }}</div>
          <div v-else-if="table.rowIdKey">{{ scope.row[table.rowIdKey] }}</div>
          <div v-else>
            {{
              scope.$index + 1 + (table.pagination.pageNo - 1) * table.pageSize
            }}
          </div></template
        ></el-table-column
      >
      <el-table-column
        v-for="(column, idx) in columnsIsVisible"
        v-if="!column.colHide"
        :key="idx"
        :prop="column.key"
        :type="column.type"
        :label="column.title"
        :width="column.width"
        :min-width="column.minWidth"
        :fixed="column.fixed"
        :sortable="column.sortable ? 'custom' : false"
        :sort-orders="['ascending', 'descending']"
        :align="column.align || 'left'"
        :show-overflow-tooltip="column.showTooltip"
        ><template v-if="column.type !== 'selection'" slot-scope="scope"
          ><cell
            v-if="column.render"
            :column="column"
            :row="scope.row"
            :index="scope.$index"
            :render="column.render"
          ></cell
          ><span v-else
            ><span v-if="column.filter">{{
              $filters[column.filter](scope.row[column.key])
            }}</span
            ><span v-if="column.enumType">{{
              $enums[column.enumType].getName(scope.row[column.key])
            }}</span
            ><span v-else>{{
              scope.row[column.key] || (scope.row[column.key] === 0 ? 0 : "--")
            }}</span></span
          ></template
      ></el-table-column>
      <div class="abcd" slot="empty">
        <div v-if="table.loading"></div>
        <div v-else>暂无数据</div>
      </div>
    </el-table>
    <el-pagination
      class="pagination"
      v-if="!table.hidePagination"
      layout="total, sizes, prev, pager, next, jumper"
      :total="table.pagination.total"
      :current-page.sync="table.pagination.pageNo"
      @size-change="handleSizeChange"
      @current-change="search(table)"
    ></el-pagination>
    <zv-dialog width="700px" title="自定义列表" :showDialog.sync="showDialog">
      <div slot="content">
        <div class="custom-dialog-list">
          <div class="custom-dialog-list-left">
            <p class="content-title">请选择</p>
          </div>
          <div class="custom-dialog-list-right">
            <el-checkbox-group v-model="selectedCheckList">
              <el-checkbox
                v-for="(column, idx) in table.columns"
                :key="idx"
                :label="column.key"
                v-if="column.key"
                >{{ column.title }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div slot="btns">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="columnsSure">确定</el-button>
      </div>
    </zv-dialog>
    <zv-dialog
      :width="table.searchDialogWidth ? table.searchDialogWidth : '500px'"
      title="自定义搜索"
      :showDialog.sync="showCustomSearchDialog"
    >
      <div slot="content">
        <zv-searchbar
          search-type="custom"
          :origin-query="table.query"
          ref="customSearch"
          :search-data="table.customSearchData"
          :showCustomSearchDialog="showCustomSearchDialog"
        ></zv-searchbar>
      </div>
      <div slot="btns">
        <el-button @click="showCustomSearchDialog = false">取消</el-button>
        <el-button type="primary" @click="customSearchClick">确定</el-button>
      </div>
    </zv-dialog>
  </div>
</template>

<script>
import cell from "./cell";
import lodash from "../../utils/tools/lodash";
import Tips from "@/utils/utils/Tips";
const offsetHight = 235;

export default {
  components: {
    cell
  },
  props: {
    table: {
      type: Object,
      required: true
    }
  },
  computed: {
    columnsIsVisible() {
      let columns = this.table.columns.filter(
        t =>
          t.type !== "selection" &&
          (this.checkList.indexOf(t.key) > -1 || !t.key)
      );
      return columns;
    }
  },
  data() {
    return {
      showDialog: false,
      showCustomSearchDialog: false,
      checkList: [],
      selectedCheckList: [],
      clonedTableQuery: {},
      // header:44 tabs:44 block-padding:15+15 search:15+32 pagination:15+28 content-bottom:15 footer:42
      // 44 - 44 - 30 - 47 -15-28 - 42 -15
      tableHeight: document.documentElement.clientHeight - offsetHight - 1
    };
  },

  methods: {
    customSearchClick() {
      // this.$refs.customSearch.setResultParams();
      this.search(this.table);
      this.showCustomSearchDialog = false;
    },

    //刷新查询表格数据
    selectRow(rows) {
      if (rows == null) {
        return;
      }
      if (!Object.prototype.toString.call(rows) === "[object Array]") {
        rows = [rows];
      }
      rows.forEach(row => {
        this.$refs.searchTable.toggleRowSelection(row, true);
      });
    },

    sortChange({ column, prop, order }) {
      // console.log(column);
      // console.log(prop);
      // console.log(order);
      if (this.table.sortChange) {
        this.table.sortChange(column, prop, order)
      }
    },

    //刷新查询表格数据
    refresh() {
      this.search(this.table);
    },

    //查询表格数据
    async search(table) {
      if (table.resetTable) {
        // 重新请求时,清空列表
        this.$set(table, "data", []);
        table.pagination.total = 0;
      }
      if (this.$refs.customSearch) {
        this.$refs.customSearch.setResultParams();
      }

      if (this.$refs.outSearch) {
        this.$refs.outSearch.setResultParams();
      }

      if (table && table.api) {
        table.loading = true;
        // console.log("rrrrrrrr")
        // console.log(table.query)
        if(table.query.toFrist) {
          // console.log('qqqqqqqq')
          this.$set(table.pagination,"pageNo",1)
          // this.$set(table.query,"toFrist",false)
        }
        if(table.query.page) {
          this.$set(table.pagination,"pageNo",1)
          table.query.page = false
        }
        let query = lodash.cloneDeep(table.query) || {};
        // lafite 2020.06.04 新增
        // console.log(table.switch)
        if(table.switch) {
          delete query.area_name
        }else {
          delete query.parent_area_name
        }
        if (!table.hidePagination) {
          query.page = table.pagination.pageNo;
          query.pagesize = table.pageSize;

          // query.index = "0";
          // query.page = table.pagination.pageNo;
          // query.rows = table.pageSize;
        }
        Object.keys(query).forEach(function(key) {
          if (!query[key] && query[key] !== 0) {
            delete query[key];
          }
        });
        try {
          let res = await table.api(query);
          // console.log(res);

          let _data = res;
          let listKey = "list";
          if (!_data[listKey]) {
            listKey = "data";
          }
          if (table.processDataFunc) {
            _data[listKey] = table.processDataFunc(_data[listKey]);
          }
          this.$set(table, "data", _data[listKey]);
          // table.pagination.total = _data.recordcount;
          table.pagination.total = _data.realrecordcount ? _data.realrecordcount : _data.recordcount;
        } catch (e) {
          // console.log(e)
        }
        table.loading = false;
        this.$nextTick(this.handlePageTurned);
      }
    },

    setTableData(tableData) {
      this.$set(this.table, "data", tableData);
    },

    customerPaginationPage(data, table) {
      let arr = data.filter((number, index) => {
        return (
          index < table.pageSize * table.pagination.pageNo &&
          index >= table.pageSize * (table.pagination.pageNo - 1)
        );
      });
      return arr;
    },
    handlePageTurned() {
      this.$emit("on-page-turned", this.table.data);
    },

    handleSelect(selection, row) {
      this.$emit("on-select", selection, row);
    },

    handleSelectionChange(val) {
      this.$emit("on-selection-change", val);
    },

    handleSelectAll(val) {
      this.$emit("on-select-all", val);
    },

    handleSizeChange(val) {
      this.table.pageSize = val;
      this.search(this.table);
    },

    columnsSure() {
      this.showDialog = false;
      this.checkList = this.$_.cloneDeep(this.selectedCheckList);
      this.search(this.table);
      localStorage.setItem(
        this.table.localColumnsKey,
        JSON.stringify(this.selectedCheckList)
      );
      // 修改自定义列表 清空再增加后的样式问题
      if (!this.table.autoHeight) {
        this.tableHeight =
          this.tableHeight ==
          document.documentElement.clientHeight - offsetHight - 1
            ? this.tableHeight - 1
            : document.documentElement.clientHeight - offsetHight - 1;
      }
    },

    init() {
      if (this.table.autoHeight) {
        this.tableHeight = "none";
      }
      let localCols = localStorage.getItem(this.table.localColumnsKey);
      if (localCols) {
        let localColsArr = JSON.parse(localCols);
        this.checkList = localColsArr;
        this.selectedCheckList = this.$_.cloneDeep(localColsArr);
      } else {
        let origin = this.table.columns
          .filter(e => !e.optional)
          .map(e => e.key);
        this.checkList = origin;
        this.selectedCheckList = this.$_.cloneDeep(origin);
      }

      this.$set(this.table, "pageSize", 10);
      this.$set(this.table, "pageNo", 1);
      this.$set(this.table, "loading", false);
      this.$set(this.table, "data", []);
      // if (!this.table.hidePagination) {
      this.$set(this.table, "pagination", {
        pageNo: 1,
        total: 0
      });
      // }
      if (!this.table.hasOwnProperty("autoLoading") || this.table.autoLoading) {
        this.search(this.table);
      }
    },

    initRefresh() {
      this.$set(this.table, "query", this.$_.cloneDeep(this.clonedTableQuery));
      if (this.$refs.outSearch) {
        this.$refs.outSearch.clearQuery();
      }
      if (this.$refs.customSearch) {
        this.$refs.customSearch.clearQuery();
      }
      this.init();
    },

    windowResize() {
      window.onresize = () => {
        this.tableHeight =
          document.documentElement.clientHeight - offsetHight - 1;
      };
    }
  },

  created() {
    this.clonedTableQuery = this.$_.cloneDeep(this.table.query);
    this.init();
  },
  mounted() {
    if (!this.table.autoHeight) {
      this.windowResize();
    }
  }
};
</script>

<!--@formatter:off-->
<style lang="sass" scoped>
.pagination
    padding: $primaryGap
    padding-bottom: 0
    text-align: right
/deep/ .el-checkbox
  margin-right: 30px
  margin-left: 0 !important
.cell
  .el-tooltip
    @include ver-center-center
  img
    cursor: pointer
    width: 20px
    height: 20px
</style>

<style lang="scss">
.el-table tr td.is-hidden > *,
.el-table tr th.is-hidden > * {
  visibility: initial;
}
.custom-dialog-list {
  display: flex;
}

.custom-dialog-list-left {
  padding-top: 8px;
  width: 56px;
  p {
    margin: 0;
    font-size: 12px;
    color: #999;
  }
}

.custom-dialog-list-right {
  flex: 1;
  .el-checkbox-group {
    line-height: auto;
  }

  .el-checkbox {
    margin-right: 0;
    margin-bottom: 15px;
    font-weight: normal;
  }

  .el-checkbox__label {
    min-width: 130px;
    font-size: 12px;
  }
}

.el-loading-mask.el-loading-mask-table {
  .el-loading-spinner {
    margin-top: -14px;
    i {
      color: #333;
      font-size: 20px;
    }
  }

  .el-loading-text {
    color: #333;
    font-size: 12px;
  }
}
</style>
